import { useState, useEffect } from 'react';
import useEnterPhoneNumberError from './useEnterPhoneNumberError';

export const useEnterPhoneNumber = (open, onCancel, onVerify) => {
  const [mobileValue, setMobileValue] = useState({});
  const [touched, setTouched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fullPhone = mobileValue?.phoneNumber ? `+${mobileValue.value}` : '';

  const { phoneError } = useEnterPhoneNumberError({
    phoneInput: fullPhone,
    touched,
  });

  const reset = () => {
    setMobileValue({});
    setTouched(false);
    setIsLoading(false);
  };

  // Receives MobileInput's onChange payload: { countryCode, phoneNumber, value, codeIndex, country }
  const handleChange = (mobilePayload) => {
    setMobileValue(mobilePayload);
    if (!touched && mobilePayload.phoneNumber) setTouched(true);
  };

  const handleCancel = () => {
    reset();
    if (onCancel) onCancel();
  };

  const handleVerify = async () => {
    setTouched(true);
    if (!getIsValid() || !onVerify) return;
    setIsLoading(true);
    try {
      await onVerify(fullPhone);
    } finally {
      setIsLoading(false);
    }
  };

  // Returns false when the field is untouched, has a validation error, or the phone number is empty
  function getIsValid() {
    return touched && !phoneError.phone && !!mobileValue?.phoneNumber;
  }

  // Reset state when dialog closes
  useEffect(() => {
    if (!open) reset();
  }, [open]);

  return {
    mobileValue,
    isLoading,
    getIsValid,
    phoneError,
    handleChange,
    handleCancel,
    handleVerify,
  };
};

export default useEnterPhoneNumber;
